import type { SVGProps } from 'react'
const SvgSyHeadphonesFill = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillOpacity={0.24}
				d="M18 12c1.108 0 2 .892 2 2v3c0 1.108-.892 2-2 2s-2-.892-2-2v-3c0-1.108.892-2 2-2"
			/>
			<path d="M18 11.4c-1.43 0-2.6 1.17-2.6 2.6v3c0 1.43 1.17 2.6 2.6 2.6s2.6-1.17 2.6-2.6v-3c0-1.43-1.17-2.6-2.6-2.6m0 1.2c.786 0 1.4.614 1.4 1.4v3c0 .786-.614 1.4-1.4 1.4s-1.4-.614-1.4-1.4v-3c0-.786.614-1.4 1.4-1.4" />
			<path
				fillOpacity={0.24}
				d="M6 12c1.108 0 2 .892 2 2v3c0 1.108-.892 2-2 2s-2-.892-2-2v-3c0-1.108.892-2 2-2"
			/>
			<path d="M6 11.4c-1.43 0-2.6 1.17-2.6 2.6v3c0 1.43 1.17 2.6 2.6 2.6s2.6-1.17 2.6-2.6v-3c0-1.43-1.17-2.6-2.6-2.6m0 1.2c.786 0 1.4.614 1.4 1.4v3c0 .786-.614 1.4-1.4 1.4s-1.4-.614-1.4-1.4v-3c0-.786.614-1.4 1.4-1.4" />
			<path d="M4 12.4a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6v-3a.6.6 0 0 0-.6-.6m16 0a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6v-3a.6.6 0 0 0-.6-.6" />
			<path d="M12 3.4c-2.3 0-4.5 1.033-6.105 2.838S3.4 10.472 3.4 13a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6c0-2.246.796-4.395 2.191-5.965S10.057 4.6 12 4.6s3.814.865 5.209 2.435S19.4 10.755 19.4 13a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6c0-2.528-.89-4.956-2.495-6.762S14.3 3.4 12 3.4" />
		</g>
	</svg>
)
export default SvgSyHeadphonesFill
